export class MaxRegisterExceededError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'MaxRegisterExceededError';
  }
}
